import {CheckoutController} from '@wc-stripe/controllers';
import {getPage, getSetting} from '@wc-stripe/utils';
import Context from '@wc-stripe/context';
import {createCreditCardGateway} from '@wc-stripe/gateways'

const settings = getSetting('stripe_cc_data');

const context = new Context(getPage());

const gateway = createCreditCardGateway(settings.cardFormType, {
    id: 'stripe_cc',
    settings,
    context
});

const controller = new CheckoutController({
    context,
    gateway,
    selector: gateway.selector
});

controller.initialize();